import { collection, doc, setDoc } from "firebase/firestore";
import React, { useState } from "react";
import { fireStore } from "../../firebaseConfig";
import { Router } from "react-router-dom";

const TerritoriesShow = () => {
  const [territoryName, setTerritoryName] = useState("");
  const [zoneName, setZoneName] = useState("");
  const [productName, setProductName] = useState("");
  const [cropName, setCropName] = useState("");

  // Add Territory...
  async function uploadTerritory() {
    if (territoryName === "" || zoneName === "") {
      alert("Fields are empty!");
      return;
    }
    const collReference = collection(fireStore, "Territories");
    const docReference = doc(collReference);

    const Territory = {
      name: territoryName.trim(),
      zone: zoneName.trim(),
    };

    await setDoc(docReference, Territory);
    alert("Territory has been added successfully.");
    setTerritoryName("");
    setZoneName("");
  }

  // Add Product...
  async function uploadProduct() {
    if (productName === "") {
      alert("Product Fields are empty!");
      return;
    }
    const collReference = collection(fireStore, "Products");
    const docReference = doc(collReference);

    const Product = {
      name: productName.trim(),
    };

    await setDoc(docReference, Product);
    alert("Product has been added successfully.");
    setProductName("");
  }

  // Add Crop...
  async function uploadCrop() {
    if (cropName === "") {
      alert("Crop Fields are empty!");
      return;
    }
    const collReference = collection(fireStore, "Crops");
    const docReference = doc(collReference);

    const Crop = {
      name: cropName.trim(),
    };

    await setDoc(docReference, Crop);
    alert("Crop has been added successfully.");
    setCropName("");
  }

  return (
    <div className="p-8 bg-lightgray overflow-hidden">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <h2 className="text-2xl font-semibold mb-4 md:mb-0 font-lato">
          {" "}
          + Add
        </h2>
        <div className="flex space-x-4"></div>
      </div>

      {/* main scrolling div */}
      <div className=" overflow-scroll h-[500px]">
        {/* Add Territory */}
        <div className="bg-liquidblue p-6 rounded-lg shadow-lg max-w-4xl mx-auto mt-4">
          <h1 className="text-xl font-semibold py-4 text-teal-800">
            Add New Territory.
          </h1>

          <div className="flex justify-start mb-4">
            <input
              type="text"
              placeholder="New Territory"
              className="w-full md:w-auto border border-gray-300 rounded-lg px-4 py-2 "
              value={territoryName}
              onChange={(e) => {
                setTerritoryName(e.target.value);
              }}
            />
          </div>
          <div className="flex justify-start mb-4">
            <input
              type="text"
              placeholder="New Zone"
              className="w-full md:w-auto border border-gray-300 rounded-lg px-4 py-2 "
              value={zoneName}
              onChange={(e) => {
                setZoneName(e.target.value);
              }}
            />
          </div>

          <button
            onClick={() => {
              uploadTerritory();
            }}
            className="bg-darkteal text-white px-10 py-2 rounded-lg font-lato font-bold self-end"
          >
            + ADD TERRITORY
          </button>
        </div>

        {/* Add Products */}
        <div className="bg-liquidblue p-6 rounded-lg shadow-lg max-w-4xl mx-auto mt-4">
          <h1 className="text-xl font-semibold py-4 text-teal-800">
            Add New Product.
          </h1>

          <div className="flex justify-start mb-4">
            <input
              type="text"
              placeholder="New Product"
              className="w-full md:w-auto border border-gray-300 rounded-lg px-4 py-2 "
              value={productName}
              onChange={(e) => {
                setProductName(e.target.value);
              }}
            />
          </div>
          {/* <div className="flex justify-start mb-4">
            <input
                        type="text"
                        placeholder="Product Name"
                        className="w-full md:w-auto border border-gray-300 rounded-lg px-4 py-2 "
                        value={zoneName}
                        onChange={(e)=>{setZoneName(e.target.value)}}
                    />
            </div> */}

          <button
            onClick={() => {
              uploadProduct();
            }}
            className="bg-darkteal text-white px-10 py-2 rounded-lg font-lato font-bold self-end"
          >
            + ADD PRODUCT
          </button>
        </div>

        {/* Add Crops */}
        <div className="bg-liquidblue p-6 rounded-lg shadow-lg max-w-4xl mx-auto mt-4">
          <h1 className="text-xl font-semibold py-4 text-teal-800">
            Add New Crop.
          </h1>

          <div className="flex justify-start mb-4">
            <input
              type="text"
              placeholder="New Crop"
              className="w-full md:w-auto border border-gray-300 rounded-lg px-4 py-2 "
              value={cropName}
              onChange={(e) => {
                setCropName(e.target.value);
              }}
            />
          </div>
          {/* <div className="flex justify-start mb-4">
            <input
                        type="text"
                        placeholder="New Zone"
                        className="w-full md:w-auto border border-gray-300 rounded-lg px-4 py-2 "
                        value={zoneName}
                        onChange={(e)=>{setZoneName(e.target.value)}}
                    />
            </div> */}

          <button
            onClick={() => {
              uploadCrop();
            }}
            className="bg-darkteal text-white px-10 py-2 rounded-lg font-lato font-bold self-end"
          >
            + ADD CROP
          </button>
        </div>
      </div>
    </div>
  );
};

export default TerritoriesShow;
